import React from "react";
import { HiOutlineArrowRight } from "react-icons/hi";
import { getOverviewHref } from "./overviewPaths";

/**
 * Small "open overview" link. Same tab by default so project work stays in one window.
 * Pass newTab when used next to a form select so the form is not abandoned.
 * @param {keyof import('./overviewPaths').overviewPath} entity
 * @param {string|number|null|undefined} id — raw id (shown in title tooltip)
 * @param {string} [title] — override tooltip
 * @param {boolean} [newTab]
 */
export default function OverviewLinkIcon({ entity, id, title, className, style, newTab = false }) {
  const href = getOverviewHref(entity, id);
  if (!href) return null;
  const tip = title ?? (id != null && id !== "" ? String(id) : "Open");
  return (
    <a
      href={href}
      {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      className={`entity-overview-link d-inline-flex align-items-center ${className || ""}`}
      title={tip}
      aria-label={tip}
      style={{
        color: "#93ab3c",
        flexShrink: 0,
        lineHeight: 1,
        ...style,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <HiOutlineArrowRight size={18} aria-hidden />
    </a>
  );
}
